const BASE_URL = "https://api.awardsuite.in/api/templates";
const BASE_URL2 = "https://api.awardsuite.in/api/admin";

// 🔹 GET ALL (event wise)
export const getTemplates = async (eventId) => {
  const res = await fetch(`${BASE_URL}?eventId=${eventId}`);
  const data = await res.json();
  return data.data;
};

// 🔹 GET ONE
export const getTemplateById = async (id, eventId) => {
  const res = await fetch(`${BASE_URL}/${id}?eventId=${eventId}`);
  const data = await res.json();
  return data.data;
};

// 🔹 CREATE
export const createTemplate = async (payload) => {
  const res = await fetch(BASE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  return res.json();
};

// 🔹 UPDATE
export const updateTemplate = async (id, payload) => {
  const res = await fetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  return res.json();
};

// 🔹 DELETE
export const deleteTemplate = async (id, eventId) => {
  const res = await fetch(`${BASE_URL}/${id}`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ eventId }),
  });

  return res.json();
};


export const getTemplateByName = async (name, eventId) => {
  const res = await fetch(
    `${BASE_URL2}/by-name?name=${encodeURIComponent(name)}&eventId=${eventId}`
  );

  const data = await res.json();
  return data.data;
};